
import React, { useState } from "react";

import { Link } from "react-router-dom";
 import WithdrawServices from '../services/WithdrawServices';
import useAsync from "../hooks/useAsync";
import TogelButtonForStatus from "./TogelButton/TogalButtonForStatus";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import ViewWithdrawl from "./View Model/ViewWithdrawlDetail";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { FaRegEye } from "react-icons/fa";
import ReactPaginate from "react-paginate";
Modal.setAppElement("#root");
function PendingWithdralList() {
  const { data, error, isLoading, run } = useAsync(WithdrawServices.getPendingWithdrawList);
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedWithdraw, setSelectedWithdraw] = useState(null);
const [payoutTransactionId, setPayoutTransactionId] = useState("");
  const [statusModalOpen, setStatusModalOpen] = useState(false);
const [currentPage, setCurrentPage] = useState(1);
const usersPerPage = 20;
  // Selected Status
  const [statusAction, setStatusAction] = useState("");

  // Admin Remark
  const [statusRemark, setStatusRemark] = useState("");

  // =========================================================
  // VIEW WITHDRAWAL
  // =========================================================

  const handleViewDetails = (withdraw) => {
    const id = withdraw?._id || withdraw?.id;

    if (!id) {
      console.log("Withdrawal ID not found");
      return;
    }

    navigate(`/view-withdrawl-detail/${id}`);
  };


  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedWithdraw(null);
  };


  const handleRequestChange = (status, withdraw) => {

    if (status === "Approved" ||status === "Rejected") {  
      setSelectedWithdraw(withdraw);
      setStatusAction(status);
      setStatusRemark("");
      setStatusModalOpen(true);
    return;
    }
  };
  const closeRemarkModal = () => {
    setStatusModalOpen(false);
    setSelectedWithdraw(null);
    setStatusRemark("");
    setStatusAction("");
     setPayoutTransactionId("");
  };


  const handleSubmitStatus = async () => {

    const id = selectedWithdraw?._id || selectedWithdraw?.id;
    try {


      let body = {
        admin_remark: statusRemark.trim(),
      };
    let result;

      if (statusAction === "Approved") {
        body.payout_transaction_id = "UTR" + Date.now();
      }
      if (statusAction === "Approved") {
        body.payout_transaction_id = "UTR" + Date.now();
        result = await WithdrawServices.approveWithdraw(id, body);
      }
      else if (statusAction === "Rejected") {
        result = await WithdrawServices.rejectWithdraw(id, body);
      }
      console.log("API RESPONSE:", result);
      if (result?.data?.status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: `Withdrawal ${statusAction} successfully`,
          timer: 1500,
          showConfirmButton: false,
        });
        closeRemarkModal();
        run();
      }
    } catch (error) {
      console.error("Status update error:", error);
    }
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(
      index === activeIndex
        ? null
        : index
    );
  };
  const formatDateTime = (isoString) => {
    if (!isoString) {
      return "-";
    }
    const date = new Date(isoString);
    const day = String(
      date.getDate()
    ).padStart(2, "0");
    const month = String(
      date.getMonth() + 1
    ).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
const filteredData =
  data?.data?.filter((withdraw) => {
    const search = searchQuery.toLowerCase().trim();

    const fullName = `${withdraw?.user_id?.firstName || ""} ${
      withdraw?.user_id?.lastName || ""
    }`
      .toLowerCase()
      .trim();

    return (
      fullName.includes(search) ||
      withdraw?.payment_method?.toLowerCase().includes(search) ||
      withdraw?.transaction_id?.toLowerCase().includes(search) ||
      withdraw?.status?.toLowerCase().includes(search) ||
      withdraw?.upi_id?.toLowerCase().includes(search) ||
      withdraw?.amount?.toString().includes(search)
    );
  }) || [];
  const indexOfLastWithdraw = currentPage * usersPerPage;
const indexOfFirstWithdraw = indexOfLastWithdraw - usersPerPage;

const currentWithdrawals = filteredData.slice(
  indexOfFirstWithdraw,
  indexOfLastWithdraw
);


  const generateExcel = () => {
    const excelData =
      filteredData.map(
        (withdraw) => ({
          "Customer Name":
            withdraw?.upi_name ||
            withdraw?.account_holder_name ||
            "-",

          Amount:
            withdraw?.amount || 0,

          "Payment Method":
            withdraw?.payment_method || "-",

          "UPI ID":
            withdraw?.upi_id || "-",

          "Transaction ID":
            withdraw?.transaction_id || "-",

          Status:
            withdraw?.status || "-",

          "Admin Remark":
            withdraw?.admin_remark || "-",

          "Created Date":
            formatDateTime(
              withdraw?.createdAt
            ),
        })
      );

    const ws =
      XLSX.utils.json_to_sheet(
        excelData
      );

    const wb =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "WithdrawalData"
    );

    XLSX.writeFile(
      wb,
      "withdrawal_data.xlsx"
    );
  };

  return (
    <>
      <div className="right_col"   role="main">
        <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
          <div className="my-auto">
            <h5 className="page-title fs-21 mb-1">
              Withdrawal List{" "}
              <span className="badge bg-orange">
                {filteredData?.length || 0}
              </span>
            </h5>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                >
                  Withdrawal List
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <button className="excel-btn" onClick={generateExcel}>
              <img
                src="img/excel.svg"
                alt="Download Excel"
              />

              Download
            </button>
          </div>
        </div>
        <div className="container-box px-0 pt-2">
          <div className="Tablesearch_design">
            <div className="row">
              <div className="col-md-6">
                <div className="d-flex align-items-center justify-content-between gap-2">
                  <input
                    type="search"
                    name="search"
                    placeholder="Search by Name, Mobile, Payment Method, Transaction ID"
                    className="form-control"
                    value={searchQuery}
                    onChange={(e) =>
                      setSearchQuery(
                        e.target.value
                      )
                    }
                  />
                  <button className="search-btn">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="container-box-inner table-reponsive-tabe">

            <table id="example"className="table table-striped"style={{ width: "100%",}}>

              <thead>

                <tr>

                  <th>#</th>

                  <th>
                    Customer Name
                  </th>

                  <th>
                    Amount
                  </th>

                  <th>
                    Payment Method
                  </th>

                  <th>
                    Transaction ID
                  </th>

                  <th>
                    Status
                  </th>

                  <th>
                    Change Status
                  </th>

                  <th>
                    Created Date
                  </th>

                  <th>
                    ACTION
                  </th>

                </tr>

              </thead>

              <tbody>

                {currentWithdrawals?.map((withdraw, i) => (

                    <tr
                      key={
                        withdraw?._id ||
                        withdraw?.id ||
                        i
                      }
                    >
       <td>{indexOfFirstWithdraw + i + 1}</td>
                  <td>{withdraw?.user_id?.firstName || ""} {" "}{withdraw?.user_id?.lastName || ""}
                      </td>
                      <td>₹{withdraw?.amount ??0}</td>

                                <td>
                        {withdraw?.payment_method ||
                          "-"}
                      </td>

                      {/* Transaction ID */}

                      <td>
                        {withdraw?.transaction_id ||
                          "-"}
                      </td>

                      {/* Status */}

                      <td>
                        {withdraw?.status ||
                          "Pending"}
                      </td>

                      {/* Change Status */}

                      <td>

                        <div className="custom-dropdown">

                          <select
                            className={`status-select ${
                              withdraw?.status
                                ?.toLowerCase() ||
                              "pending"
                            }`}
                            value={
                              withdraw?.status ||
                              "Pending"
                            }
                            onChange={(e) =>
                              handleRequestChange(
                                e.target.value,
                                withdraw
                              )
                            }
                            disabled={
                              withdraw?.status
                                ?.toLowerCase() !==
                              "pending"
                            }
                          >

                            <option value="Pending">
                              ⏳ Pending
                            </option>

                            <option value="Approved">
                              ✅ Approved
                            </option>

                            <option value="Rejected">
                              ❌ Rejected
                            </option>

                          </select>

                        </div>

                      </td>

                      {/* Created */}

                      <td>
                        {formatDateTime(
                          withdraw?.createdAt
                        )}
                      </td>

                      {/* Action */}

                      <td>

                        <div className="action_toggle_outer">

                          <button
                            className="action_toggle"
                            onClick={() =>
                              toggleActionMenu(
                                i
                              )
                            }
                          >
                            <i className="fa fa-ellipsis-v" />
                          </button>

                          {activeIndex ===
                            i && (

                            <div className="action_toggle_content product-edit show d-block">

                              <ul className="list-unstyled">

                                {/* Close */}

                                <li>

                                  <button
                                    className="close_toggle"
                                    onClick={() =>
                                      toggleActionMenu(
                                        null
                                      )
                                    }
                                  >
                                    <i className="fa fa-close" />
                                  </button>

                                </li>

                                {/* View */}

                                <li>

                                  <button
                                    className="approve"
                                    style={{
                                      backgroundColor:
                                        "#60B930",
                                    }}
                                    onClick={() =>
                                      handleViewDetails(
                                        withdraw
                                      )
                                    }
                                  >

                                    <FaRegEye />

                                    {" "}

                                    View

                                  </button>

                                </li>

                              </ul>

                            </div>

                          )}

                        </div>

                      </td>

                    </tr>

                  )
                )}

              </tbody>

            </table>
            <div className="pagination">
  <ReactPaginate
    pageCount={Math.ceil(
      (filteredData?.length || 0) / usersPerPage
    )}
    pageRangeDisplayed={3}
    marginPagesDisplayed={1}
    onPageChange={(data) => {
      setCurrentPage(data.selected + 1);
    }}
    containerClassName="pagination"
    activeClassName="active"
    previousLabel="Previous"
    nextLabel="Next"
    breakLabel="..."
    breakClassName="break-me"
    pageLinkClassName="page-link"
    previousLinkClassName="page-link"
    nextLinkClassName="page-link"
    pageClassName="page-item"
    previousClassName="page-item"
    nextClassName="page-item"
    disabledClassName="disabled"
    forcePage={currentPage - 1}
  />
</div>

          </div>

        </div>

        {/* =========================================================
            STATUS CHANGE MODAL
        ========================================================= */}

        <Modal
          isOpen={
            statusModalOpen
          }
          onRequestClose={
            closeRemarkModal
          }
          shouldCloseOnOverlayClick={
            false
          }
          shouldCloseOnEsc={
            true
          }
          contentLabel="Change Withdrawal Status"
          className="status-modal-content"
          overlayClassName="status-modal-overlay"
        >

          <div className="status-modal-box">

            {/* Header */}

            <div className="status-modal-header">

              <h4>
                Change Status
              </h4>

              <button
                type="button"
                className="btn btn-danger"
                onClick={
                  closeRemarkModal
                }
              >
                ×
              </button>

            </div>

            <div className="status-modal-body">

              <div className="form-group mb-3">

                <label className="form-label">
                  Status
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={
                    statusAction
                  }
                  readOnly
                />

              </div>
              <div className="form-group mb-3">
                <label className="form-label">
                  Remark{" "}<span className="text-danger">*</span>
                </label>

                <textarea
                  className="form-control"
                  rows="4"
                  placeholder={`Enter remark for ${statusAction}...`}
                  value={statusRemark}
                  onChange={(e) =>setStatusRemark(e.target.value)
                  }
                />
              </div>
            </div>
            <div className="status-modal-footer">

              <button
                type="button"
                className="btn btn-danger"
                onClick={
                  closeRemarkModal
                }
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn btn-success"
                onClick={handleSubmitStatus}
              >
                Change Status
              </button>

            </div>

          </div>

        </Modal>
        <Modal isOpen={ isModalOpen}
          onRequestClose={closeModal}
          contentLabel="View Withdrawal"
          className="modal-content"
          overlayClassName="modal-overlay">
          <ViewWithdrawl withdraw={selectedWithdraw }
            closeModal={closeModal}
          />
        </Modal>

      </div>
    </>
  );
}
 export default PendingWithdralList;
